export default {
  applies_to_articles: 'Koskee seuraavia tuotteita',
};
